var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoriaCactos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C17.8675 0 21 3.043 21 6.8V22.1H22.75C23.7125 22.1 24.5 21.335 24.5 20.4V10.2C24.5 9.74913 24.6844 9.31673 25.0126 8.99792C25.3407 8.67911 25.7859 8.5 26.25 8.5C26.7141 8.5 27.1593 8.67911 27.4874 8.99792C27.8156 9.31673 28 9.74913 28 10.2V20.4C28 23.222 25.655 25.5 22.75 25.5H21V30.6H24.5V34H3.5V30.6H7V20.4H5.25C3.85761 20.4 2.52226 19.8627 1.53769 18.9062C0.553124 17.9498 0 16.6526 0 15.3V11.9C0 11.4491 0.184375 11.0167 0.512563 10.6979C0.840752 10.3791 1.28587 10.2 1.75 10.2C2.21413 10.2 2.65925 10.3791 2.98744 10.6979C3.31563 11.0167 3.5 11.4491 3.5 11.9V15.3C3.5 16.235 4.2875 17 5.25 17H7V6.8C7 3.043 10.1325 0 14 0ZM14 3.4C13.0717 3.4 12.1815 3.75821 11.5251 4.39584C10.8687 5.03346 10.5 5.89826 10.5 6.8V30.6H17.5V6.8C17.5 5.89826 17.1313 5.03346 16.4749 4.39584C15.8185 3.75821 14.9283 3.4 14 3.4Z",
    fill: "#69BF8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriaCactos);
export default __webpack_public_path__ + "static/media/categoriaCactos.2cfb92b5d6ec81426deeab218ca26b53.svg";
export { ForwardRef as ReactComponent };